import { FooterActionsButtonContainerProps } from './footer-actions-button-container.model';
import { FooterActionsButtonContainerView } from './footer-actions-button-container.view';

export const FooterActionsButtonContainerController = (
  props: FooterActionsButtonContainerProps
) => {
  return <FooterActionsButtonContainerView {...props} />;
};
